function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2857 0H2.7058C1.21295 0 0 1.22991 0 2.73973V35.2603C0 36.7701 1.21295 38 2.7058 38H35.2857C36.7786 38 38 36.7701 38 35.2603V2.73973C38 1.22991 36.7786 0 35.2857 0ZM11.4848 32.5714H5.85268V14.4366H11.4933V32.5714H11.4848ZM8.66875 11.9598C6.86205 11.9598 5.40312 10.4924 5.40312 8.6942C5.40312 6.89598 6.86205 5.42857 8.66875 5.42857C10.467 5.42857 11.9344 6.89598 11.9344 8.6942C11.9344 10.5009 10.4754 11.9598 8.66875 11.9598V11.9598ZM32.5969 32.5714H26.9647V23.75C26.9647 21.6464 26.9223 18.9406 24.0384 18.9406C21.1036 18.9406 20.654 21.2308 20.654 23.5973V32.5714H15.0219V14.4366H20.425V16.9134H20.5013C21.2562 15.4884 23.0969 13.9871 25.8366 13.9871C31.5366 13.9871 32.5969 17.7446 32.5969 22.6304V32.5714V32.5714Z",
  fill: "white"
});

var SvgLinkedIn = function SvgLinkedIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LinkedIn.594a3643.svg";
export { ForwardRef as ReactComponent };